import { User } from 'app/models/Users';
import { ServerResponse } from './../../models/ServerResponse';
import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { SplendidCRMDFService } from 'app/services/SplendidCRMDFService';

@Component({
  selector: 'app-sidebar-header',
  templateUrl: './app-sidebar-header.component.html',
  styleUrls: ['./app-sidebar-header.component.scss'],
})
export class AppSidebarHeaderComponent { 
  @Input() isMinimizado;
  userProfile:User;
  fullName;

  constructor(
    private splendidService: SplendidCRMDFService
  ) {
    this.splendidService.getUserProfile().subscribe(userProfile =>{
      this.userProfile = userProfile;
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/app-sidebar-header/app-sidebar-header.component.ts